/**
 * Removes a level of nesting from an array by adding a joiner in between array elements
 * @example
 * ```ts
 * const result = removeNestingWith(z, [[a, b], [c], [d, e]])
 * // result = [a, b, z, c, z, d, e]
 * ```
 * @param arrays
 * @param joiner
 */
export function removeNestingWith<T>(joiner: T, arrays: T[][]): T[] {
  return arrays.flatMap((section) => [...section, joiner]).slice(0, -1);
}
